<template>
  <div class="dropdown-container">
    <b-dropdown
      size="sm"
      toggle-class="buttonclass"
      class="w-100 column drop-button"
      variant="outline-secondary"
      :text="label"
      :disabled="disabled"
    >
      <b-dropdown-item v-if="dropdownInfoText" style="width: 100%;">
        <div v-html="dropdownInfoText"></div>
      </b-dropdown-item>
      <template #button-content>
        <span class="dropdown-label">{{ label }}</span>
      </template>
      <b-form-group class="checkboxcolumn">
        <!-- Render "select all" checkbox only if maxSelectable is Infinity -->
        <b-form-checkbox
          v-if="maxSelectable === Infinity"
          v-model="allIsSelected"
          class="select-all-checkbox"
          @change="selectAll"
        >
          {{ allIsSelected ? 'Unselect all' : 'Select all' }}
        </b-form-checkbox>
        <b-form-checkbox-group
          v-model="selected"
          :options="optionsArray"
          :class="['selection-checkboxes', selectionCheckboxesClass]"
          stacked
          @click.native="allIsSelected = false"
        />
      </b-form-group>
    </b-dropdown>
  </div>
</template>

<script>
export default {
  name: 'CheckboxDropdownOptions',
  props: {
    optionsArray: {
      type: Array,
      default: () => [],
    },
    labelTypeName: {
      type: String,
      default: '',
    },
    initialSelection: {
      type: Array,
      default: () => [],
    },
    dropdownInfoText: {
      type: String,
      default: '',
    },
    maxSelectable: {
        type: Number,
        default: Infinity
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      allIsSelected: false,
      selected: [],
      internalInitialSelection: [],
    };
  },
  computed: {
    label() {
      const numberOfSelected = this.selected.length;
      if (numberOfSelected === 0) {
        return this.labelTypeName;
      }
      return `${this.labelTypeName} (${numberOfSelected} ${numberOfSelected !== 1 ? 'valda' : 'vald'} av ${this.optionsArray.length})`;
    },
  selectionCheckboxesClass() {
    return {
      'no-margin': this.maxSelectable !== Infinity
    };
  },
  },
  watch: {
    selected(newVal) {
      if (newVal.length > this.maxSelectable) {
        this.selected.shift();
      }
      this.allIsSelected = this.selected.length === this.optionsArray.length;
      this.$emit('onInputChanged', this.selected);
    },
    optionsArray() {
      this.updateInternalInitialSelection();
    },
    initialSelection() {
      this.updateInternalInitialSelection();
    },
  },
  methods: {
    selectAll(checked) {
      this.selected = checked ? this.optionsArray.slice(0, this.maxSelectable) : [];
    },
    updateInternalInitialSelection() {
      this.internalInitialSelection = this.maxSelectable !== Infinity 
        ? this.initialSelection.slice(0, this.maxSelectable) 
        : this.initialSelection;
      
      this.selected = this.internalInitialSelection;
    },
  },
  mounted() {
    this.updateInternalInitialSelection();
  },
};
</script>

<style scoped>
.dropdown-label {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  max-width: 100%;
  display: inline-block;
  vertical-align: middle;
}
.selection-checkboxes {
  margin: 0 1.25rem;
}
.no-margin {
  margin: 0;
}
.checkboxcolumn >>> .custom-checkbox {
  display: flex;
  margin: 0 1.5rem;
}
</style>
<style>
.checkboxcolumn > div > div > .custom-checkbox label,
.checkboxcolumn > div > div .custom-control-label {
  display: flex;
  align-items: center;
}
</style>
